// Not the worker-loader! syntax to keep Webpack happy
import Worker from 'worker-loader!./worker'
import { l } from '../lib/imports'

export type WorkerType = 'test-worker' | 'find-path' | 'find-path-2'

const worker = new Worker()
let idCounter = 100

interface IWorkerQueueItem {
  id: number
  onDone: (result: any) => void
  isDone: boolean
}
let queue: IWorkerQueueItem[] = []

worker.onmessage = (event: any) => {
  console.log('WW', 'returned', event.data.id) //, event, event.data.result, queue)
  // console.log('we got a result', event.data.result)

  l.forEach(queue, (c) => {
    if (c.id === event.data.id) {
      c.isDone = true
      c.onDone(event.data.result)
    }
  })
  // Remove dead
  for (let i = 0; i < queue.length; i++) {
    if (queue[i].isDone) {
      queue.splice(i, 1)
      i--
    }
  }
}

export function testIt(onDone: (result: any) => void) {
  // worker.postMessage({ limit: 10 })
  call('test-worker', { limit: 10 }, onDone)
}

export function call(
  type: WorkerType,
  args: any,
  onDone: (result: any) => void,
) {
  idCounter++
  worker.postMessage({ id: idCounter, type, args })
  queue.push({ id: idCounter, isDone: false, onDone })
  return idCounter
}
